export default __webpack_public_path__ + "static/media/t.af0c92d9.mp4";